import { render, staticRenderFns } from "./BaseGroup.vue?vue&type=template&id=2cbda7e6&"
import script from "./BaseGroup.vue?vue&type=script&lang=js&"
export * from "./BaseGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports